import React from "react";
import ClientSubmission from "./ClientSubmission/ClientSubmission";
import { NewTab, PageTab } from "../../../components";
import { useModuleAccess } from "../../../hooks";

const ClientSubmissions = () => {
  const ClientMenus = [
    {
      title: "Client Submissions",
      page: <ClientSubmission />,
      type: "main",
      id: "clientsubmissions_clientsubmissions",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: ClientMenus,
    parentId: "clientsubmissions",
  });

  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="client-submissions"
    />
  );
};

export default ClientSubmissions;
